import { createUrl } from '@/utils';

const auth = createUrl('registration');

const register = auth('cash-register');
const state = auth('cash-register/state');

export const registrationEndpoints = { register, state };
